import Amplify from "aws-amplify";

import config from "./config";

const awsExports = Amplify.configure({
  Auth: {
    region: config.cognito.REGION,
    userPoolId: config.cognito.USER_POOL_ID,
    userPoolWebClientId: config.cognito.APP_CLIENT_ID,
    identityPoolId: config.cognito.IDENTITY_POOL_ID,
    cookieStorage: {
      domain: config.cognito.COOKIE_DOMAIN,
      path: "/",
      expires: 365,
      secure: config.cognito.COOKIE_SECURE,
      sameSite: config.cognito.COOKIE_SAME_SITE,
    },
  },
  API: {
    endpoints: [
      {
        name: "HublyAPI",
        endpoint: config.gateway.URL,
      },
    ],
  },
});

export default awsExports;
